import { createRequest, RequestConfig } from 'app/common/api';

import { TTicketsReportConstraints } from '../core/tickets-report-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_report_tickets',
};

export const getTicketsReportRequest = (
  constraints?: TTicketsReportConstraints
) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
